export default "__VITE_ASSET__CkwdTDnb__"